import { createEvent, createStore } from 'effector';

export const setSkipQrScan = createEvent<boolean>();

export const $skipQrScan = createStore(false).on(setSkipQrScan, (_, value) => value);
